import { useState } from "react";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { handleModal } from "../../../redux/actions/modals";
import { Col, Container, Row } from "react-bootstrap";
import moment from "moment";
import { SCRIP_INSTRUMENTS } from "../../../utils/global_variables";
import { setShowSideOrderConfirmation, setShowSideTrayPlaceOrder, updateMultiLegOrderConfirmed } from "../../../redux/actions/orders";

const LtpPriceBandValidationInfoModal = ({legsThatFailLtpPriceValidation}) => {
    const modals = useSelector(state => state.modals.modals);
    const dispatch = useDispatch();
    // state variable to map restrictive or info mode; if isRestrictive is false then it is in isInfo mode as modal only opens if one of these two conditions are true
    const [isRestrictiveModal, setRestrictiveModal] = useState(legsThatFailLtpPriceValidation.some(leg => leg.isRestrictive));

    const handleModalClose = () => {
        dispatch(handleModal([{"LTP_PRICE_BAND_VALIDATION_ERROR_MODAL": false}]));
    };

    // Function to confirm order in case of info validation message or close modal in case of restrictive message
    const handleModalBtnClick = () => {
        if(isRestrictiveModal) {
            // don't allow user to proceed with order amd close modal
            dispatch(handleModal([{"LTP_PRICE_BAND_VALIDATION_ERROR_MODAL": false}]));
        }
        else {
            // close validation modal
            dispatch(handleModal([{"LTP_PRICE_BAND_VALIDATION_ERROR_MODAL": false}]));
            // open confirm modal
            dispatch(updateMultiLegOrderConfirmed(true));
            // Adds code to proceed with order confirmation mode in sidetray after clicking Confirm on LTP validation
            dispatch(setShowSideTrayPlaceOrder(false));
            dispatch(setShowSideOrderConfirmation(true));
        }
    }
    return (
        <BzModal data-testid="ltp-price-band-validation-modal" size='md' show={modals["LTP_PRICE_BAND_VALIDATION_ERROR_MODAL"]} onHide={handleModalClose} className='modal-breeze'>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>Price Band Validation</div>
                        </Col>
                        <Col  md={1} className='d-flex justify-content-end align-self-center'>
                            <div data-testid='ltp-price-band-validation-modal-close-icon' className='icon-16 icon-close icon-dark' onClick={handleModalClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    {
                    legsThatFailLtpPriceValidation.map(leg => (
                        <Row className='g-0 pb-3'>
                            <Col className='d-flex flex-column justify-content-start'>
                                <div className='d-flex justify-content-start align-items-center'>
                                    <span className='font-medium font-size4 color-text me-1'>{leg?.symbol}</span>
                                    <span className='font-regular font-size4 color-subtext'>{moment(leg?.expiryDate).format('DD MMM YYYY')?.toString()} {leg?.instrument?.includes(SCRIP_INSTRUMENTS.FUT) ? SCRIP_INSTRUMENTS.FUT : SCRIP_INSTRUMENTS.OPT} {leg?.exchange.substr(0, 3)} {leg?.activeButtonToggleIndex === 0 ? "BUY" : "SELL"}</span>
                                </div>
                                <div className='font-regular font-size3 color-text p-t-1'>{leg.errorMsgToShow}</div>
                            </Col>
                        </Row>
                     ))
                    }
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-end'>
                            <BzButton data-testid={`ltp-price-band-validation-modal-${isRestrictiveModal ? "ok" : "confirm"}-button`} className='btn btn-md btn-outline' onClick={handleModalBtnClick}>
                                {isRestrictiveModal ? "Ok" : "Confirm"}
                            </BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    )
}

export default LtpPriceBandValidationInfoModal;